// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader___oc_B","loader":"Preloader_loader__OWdUC","spin":"Preloader_spin__Tga64"};